import Image, { StaticImageData } from "next/legacy/image";
import Link from "next/link";
import { useRef } from "react";

import { useTimeCountdown } from "@/businessLogics/_common/utils/calculate";

import * as S from "./LandingPageHeroOrganism.style";
import timerLogo from "/public/images/landing/hero/timer_logo.svg";
import { useRouter } from "next/router";

export let heroRef;

export default function LandingPageHeroOrganism({
  course,
  titleData,
  heroImage,
  ctaHandler,
  ctaText,
  // isLinkBlock,
  isAlimSeason,
  landingInfo,
  endDate,
}: {
  course: string;
  titleData: () => { title: JSX.Element; subtitle: JSX.Element };
  heroImage: { desktop: StaticImageData; mobile: StaticImageData };
  ctaHandler: ({ button_text, location }) => void;
  ctaText: string;
  // isLinkBlock: boolean;
  summaryInfo?: { title: string; content: string }[];
  isAlimSeason?: boolean;
  landingInfo?: { title: string; content?: string; subContent?: string }[];
  endDate?: { year: number; month: number; date: number; hour: number };
}) {
  heroRef = useRef();
  const { title, subtitle } = titleData();
  const isWithoutRedirectCTA =
    // ctaText?.includes("알림") || ctaText === "" || isLinkBlock;
    ctaText?.includes("알림") || ctaText === "";

  const leftTimes = useTimeCountdown(
    new Date(),
    new Date(endDate?.year, endDate?.month, endDate?.date, endDate?.hour)
  );
  const router = useRouter();

  function handleClickCta() {
    alert(
      "PM 코스 4기 모집이 조기 종료되었습니다.\n기타 문의는 홈페이지의 [1:1 문의]를 이용해 주세요."
    );
    router.push("/");
    return;
    ctaHandler({ button_text: ctaText, location: "top" });
  }

  return (
    <S.Background>
      <S.Wrapper>
        <S.DesktopBackgroundImage>
          <Image
            src={heroImage.desktop}
            alt="background"
            priority
            quality={100}
            width={374}
            height={481}
          />
        </S.DesktopBackgroundImage>
        <S.TextAndButtonWrapper>
          <S.TitleWrapper>
            <S.SubTitle>{subtitle}</S.SubTitle>
            <S.Title>{title}</S.Title>
          </S.TitleWrapper>

          <S.MobileBackgroundImage>
            <Image
              src={heroImage.mobile}
              alt="background"
              priority
              quality={100}
            />
          </S.MobileBackgroundImage>

          {isAlimSeason && (
            <S.EndWrapper>
              <S.EndLine />
              3기 모집이 마감되었습니다.
              <S.EndLine />
            </S.EndWrapper>
          )}

          <S.InformationWrapper isAlimSeason={isAlimSeason}>
            {isAlimSeason && (
              <S.InformationHeadTitle>4기 모집 안내</S.InformationHeadTitle>
            )}

            {landingInfo &&
              landingInfo
                .filter((info) => {
                  if (isAlimSeason) {
                    return info.title !== "지원 마감";
                  } else {
                    return info.title !== "모집 일정";
                  }
                })
                .map((info, index) => (
                  <S.InformationLine key={index}>
                    <S.InformationTitle>{info.title}</S.InformationTitle>
                    {info.content && (
                      <S.InformationContent>
                        {info.content}
                      </S.InformationContent>
                    )}
                    {info.subContent && (
                      <S.InformationSubContent>
                        {info.subContent}
                      </S.InformationSubContent>
                    )}
                    {info.title === "지원 마감" && (
                      <>
                        <Image src={timerLogo} alt="timer" />
                        <S.InformationTimer>
                          {leftTimes
                            ? `${leftTimes.day}일 ${leftTimes.hour}:${leftTimes.min}:${leftTimes.sec} 남음 `
                            : "모집 마감"}
                        </S.InformationTimer>
                      </>
                    )}
                  </S.InformationLine>
                ))}
          </S.InformationWrapper>
          <S.CtaWrapper>
            <S.Cta onClick={handleClickCta}>{ctaText}</S.Cta>
          </S.CtaWrapper>
        </S.TextAndButtonWrapper>
      </S.Wrapper>
    </S.Background>
  );
}
